import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DatetimeField } from '~admin/view/components/ui/form/fields/field-datetime.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

export interface DoorsDatetimeFormData {
  doorsOpenDate: string;
}

export const DoorsDatetime: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        <RestrictBox>
          <DatetimeField
            name={'doorsOpenDate'}
            label={t('createEvent.eventDetails.dateTime.doors.startDate')}
          />
        </RestrictBox>
      </Row>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
`;

const Row = styled(Box)`
  margin-top: 12px;
  > div:not(:first-child) {
    margin-left: 50px;
  }
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-datetime-details/doors-datetime.component.tsx